(ns journal-app-client.translations)

(def dictionary
  {})

(defn tr [& args]
  (str args))